// extracted by mini-css-extract-plugin
export default {"processing":"MailChimp_processing__6WGD2","error":"MailChimp_error__GZlzg","success":"MailChimp_success__-Y2DP"};